/**
 * Centralized password strength logic.
 * Used in SignUp and ResetPassword forms.
 */

export interface PasswordStrengthResult {
  score: number; // 0-5
  label: string;
  color: string;
}

const STRENGTH_LABELS = ["Too Short", "Weak", "Fair", "Good", "Strong", "Very Strong"];
const STRENGTH_COLORS = ["#ccc", "#ff4f87", "#ff914d", "#f2c94c", "#57f287", "#2ecc71"];

/**
 * Calculates password strength score (0-5)
 */
export function getPasswordStrength(pwd: string): number {
  let score = 0;
  if (pwd.length >= 6) score++;
  if (/[A-Z]/.test(pwd)) score++;
  if (/[0-9]/.test(pwd)) score++;
  if (/[^A-Za-z0-9]/.test(pwd)) score++;
  if (pwd.length >= 12) score++;
  return score;
}

/**
 * Returns the full strength result with label and color
 */
export function getPasswordStrengthResult(pwd: string): PasswordStrengthResult {
  const score = getPasswordStrength(pwd);
  return {
    score,
    label: STRENGTH_LABELS[score],
    color: STRENGTH_COLORS[score],
  };
}

/**
 * react-hook-form validation rules for password fields
 */
export const passwordRules = {
  required: "Password is required" as const,
  minLength: { value: 6, message: "At least 6 characters" } as const,
};
